<template>
  <div class="white-bg">
    <AssignEmployee @updatePayload="updatePayload" :payload="payload" />
    <div class="btn-wrapper mt-20 sec-span">
      <el-button
        class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end mr-15"
        @click.prevent="assign"
        :loading="loading"
        >Assign</el-button
      >
      <button class="btn-cancel mr-15" @click="$router.go(-1)">Cancel</button>
    </div>
  </div>
</template>

<script>
import AssignEmployee from "@/components/general/AssignEmployee";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("admin/attendance/overtime");

export default {
  components: {
    AssignEmployee,
  },
  data() {
    return {
      titleText: "Work Rate",
      backLink: "/admin/attendance/overtime/settings/work-rate",
      loading: false,
      selectedEmployees: [],
      payload: {
        assignedEmployees: [],
        unAssignedEmployees: [],
        newlyAssigned: [],
        initiallyAssignedEmployees: [],
      },
    };
  },
  mounted() {
    const id = this.$route.params.id;
    this.fetchAssignableWorkrate(id);
  },
  methods: {
    ...mapActions(["assignEmployeeWorkrate", "getWorkrateAssignable"]),
    updatePayload(payload) {
      this.payload = payload;
    },
    assign() {
      const id = this.$route.params.id;
      const { assignedEmployees, initiallyAssignedEmployees } = this.payload;
      const currentIds = assignedEmployees.map(e => e.id);
      const initialIds = initiallyAssignedEmployees.map(e => e.id);

      const assign_category_type_ids = currentIds.filter(
        id => !initialIds.includes(id)
      );
      const unassign_category_type_ids = initialIds.filter(
        id => !currentIds.includes(id)
      );

      if (
        !assign_category_type_ids.length &&
        !unassign_category_type_ids.length
      ) {
        return this.$notification.error("Kindly select or deselect employees");
      }
      this.loading = true;

      this.$store
        .dispatch("admin/attendance/overtime/assignEmployeeWorkrate", {
          data: {
            category_type: "employee",
            assign_category_type_ids,
            unassign_category_type_ids,
          },
          id,
        })
        .then(() => {
          this.loading = false;
          this.$router.push("/admin/attendance/overtime/settings/work-rate");
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchAssignableWorkrate(id) {
      this.loading = true;
      this.$store
        .dispatch("admin/attendance/overtime/getWorkrateAssignable", id)
        .then(response => {
          this.loading = false;
          const employees = response.data.employees;
          this.payload.assignedEmployees = [...employees];
          this.payload.initiallyAssignedEmployees = [...employees];
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
